// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Active_wrapper__381Xb","organisationName":"Active_organisationName__1ujPh"};